/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hour_Calm_Tuna_SwimInputs */

const fr_hour_calm_tuna_swim = /** @type {(inputs: Hour_Calm_Tuna_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la mise à jour`)
};

/**

* @param {Hour_Calm_Tuna_SwimInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const hour_calm_tuna_swim = /** @type {((inputs?: Hour_Calm_Tuna_SwimInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hour_Calm_Tuna_SwimInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_hour_calm_tuna_swim(inputs)
});